'use strict';

const SHIPPING_METHODS_RECOMMEND = {
  FAST: 'fast',
  LOWCOST: 'lowCost'
};

const SHIPPING_METHODS_RECOMMEND_PATTERN = Object.keys(
  SHIPPING_METHODS_RECOMMEND
).map((key) => {
  return SHIPPING_METHODS_RECOMMEND[key];
});

/**
 * @note SHIPPING_METHODS の配送方法を増減させる場合は、
 * 経理チームの業務に影響を与えるため keiri@tokyootakumode.com へ事前連絡すること
 **/
const SHIPPING_METHODS = {
  EMS: {
    code: 111,
    max_weight: 30000,
    value: 'EMS',
    label: 'EMS',
    average_delivery_time: '1 to 2 Weeks',
    recommends: SHIPPING_METHODS_RECOMMEND.FAST
  },
  AIR_PARCEL: {
    code: 221,
    max_weight: 30000,
    value: 'Air Parcel',
    label: 'Air Parcel',
    average_delivery_time: '2 to 3 Weeks'
  },
  SAL_PARCEL: {
    code: 231,
    max_weight: 30000,
    value: 'SAL Parcel',
    label: 'SAL Parcel',
    average_delivery_time: '3 to 5 Weeks'
  },
  // @deprecated
  // 2026年からサービス終了
  AIR_SPR: {
    code: 321,
    max_weight: 2000,
    value: 'Air_SPR',
    label: 'Air Small Packet Registered',
    short_label: 'Air SPR',
    average_delivery_time: '2 to 3 Weeks',
    recommends: SHIPPING_METHODS_RECOMMEND.LOWCOST
  },
  SAL_SPR: {
    code: 331,
    max_weight: 2000,
    value: 'SAL_SPR',
    label: 'SAL Small Packet Registered',
    short_label: 'SAL Parcel',
    average_delivery_time: '3 to 5 Weeks',
    recommends: SHIPPING_METHODS_RECOMMEND.LOWCOST
  },
  NAP: {
    code: null,
    max_weight: 2721.55422,
    value: 'NAP',
    label: 'US Standard Shipping (USPS/FedEx)',
    short_label: 'Standard',
    average_delivery_time: '1 to 2 Weeks'
  },
  TMG_PICK: {
    code: null,
    max_weight: 30000,
    value: 'TMG_PICK',
    label: '',
    average_delivery_time: ''
  },
  YU_MAIL: {
    code: null,
    max_weight: 1000,
    value: 'Yu Mail',
    label: '',
    average_delivery_time: ''
  },
  NEWGISTICS_5: {
    code: null,
    max_weight: null,
    value: 'Newgistics_5',
    label: 'International Shipping (US-Canada)',
    short_label: 'US-to-Canada',
    average_delivery_time: '4-7 days (2-5 business days)',
    short_average_delivery_time: '2-5 business days'
  },
  USPS_PRIORITY_MAIL: {
    code: null,
    max_weight: null,
    value: 'USPS_PRIORITY_MAIL',
    label: 'Priority',
    short_label: 'Priority',
    average_delivery_time: '4-7 days (2-5 business days)',
    short_average_delivery_time: '2-5 business days'
  },
  UPSG: {
    code: null,
    max_weight: null,
    value: 'UPSG',
    label: 'Standard',
    short_label: 'Standard',
    average_delivery_time: '5-14 days (5-10 business days)',
    short_average_delivery_time: '5-10 business days'
  },
  YAMATO: {
    // TOM Admin と配送管理が独立しているため value のみ定義
    code: null,
    max_weight: null,
    value: 'YAMATO',
    label: '',
    // エンドユーザーからの購入には使用しないため未設定
    average_delivery_time: ''
  },
  SAGAWA: {
    // TOM Admin と配送管理が独立しているため value のみ定義
    code: null,
    max_weight: null,
    value: 'SAGAWA',
    label: '',
    // エンドユーザーからの購入には使用しないため未設定
    average_delivery_time: ''
  },
  CHARTER: {
    code: null,
    max_weight: null,
    value: 'CHARTER',
    label: '',
    average_delivery_time: ''
  },
  SURFACE_PARCEL: {
    code: 241,
    max_weight: 30000,
    value: 'Surface Parcel',
    label: 'Surface Parcel (Sea Mail)',
    short_label: 'Surface',
    average_delivery_time: '4-16 weeks (1-4 months)',
    short_average_delivery_time: '4-16 weeks'
  },
  // 汎用出荷機能(/admin/general_shipment/ichikawa)でのみ利用
  SURFACE_SPR: {
    code: null,
    max_weight: 2000,
    value: 'Surface SPR',
    label: '',
    average_delivery_time: ''
  },
  FEDEX_PRIORITY: {
    code: null,
    max_weight: null,
    value: 'FEDEX_PRIORITY',
    label: 'FedEx International Priority',
    short_label: 'FedEx',
    average_delivery_time: '2-5 days (2-3 business days)',
    short_average_delivery_time: '2-3 business days'
  },
  FEDEX_ICP: {
    code: null,
    max_weight: null,
    value: 'FEDEX_ICP',
    label: 'FedEx International Connect Plus',
    short_label: 'FedEx',
    average_delivery_time: '2-5 days (2-3 business days)',
    short_average_delivery_time: '2-3 business days'
  },
  FEDEX_ICP_DDP: {
    code: null,
    max_weight: null,
    value: 'FEDEX_ICP_DDP',
    label: 'FedEx International Connect Plus (DDP)',
    short_label: 'FedEx (DDP)',
    average_delivery_time: '2-5 days (2-3 business days)',
    short_average_delivery_time: '2-3 business days'
  },
  BULK_SHIPPING_UPSG: {
    code: null,
    max_weight: null,
    value: 'BULK_SHIPPING_UPSG',
    label: 'TOM Surface Mail (delivered by UPS)',
    short_label: 'TOM Surface Mail',
    average_delivery_time: '8 to 16 weeks',
    short_average_delivery_time: '8 to 16 weeks'
  },
  DHL_EXPRESS: {
    code: null,
    max_weight: null,
    value: 'DHL_EXPRESS',
    label: 'DHL Express',
    short_label: 'DHL',
    average_delivery_time: '2-5 days (2-3 business days)',
    short_average_delivery_time: '2-3 business days'
  },
  // @deprecated
  // 2026年からサービス終了
  AIR_SP: {
    code: 821,
    max_weight: 2000,
    value: 'Air_SP',
    label: 'Air Small Packet',
    short_label: 'Air SP',
    average_delivery_time: '2 to 3 Weeks',
    recommends: SHIPPING_METHODS_RECOMMEND.LOWCOST
  },
  ECMS: {
    code: null,
    max_weight: 30000,
    value: 'ECMS',
    label: 'ECMS',
    average_delivery_time: '2 to 3 Weeks'
  },
  EPACKET_LIGHT: {
    code: null,
    max_weight: 2000,
    value: 'EPACKET_LIGHT',
    label: 'AIR Packet',
    short_label: 'AIR Packet',
    average_delivery_time: '2 to 3 Weeks'
  },
  // _JP suffix の shipping_method は factory で配送方法を選択されます
  // 実際の配送方法は通常 YAMATO もしくは SAGAWA です
  MSS_JP: {
    code: null,
    max_weight: null,
    value: 'MSS_JP',
    label: '',
    average_delivery_time: ''
  },
  SHOPIFY_JP: {
    code: null,
    max_weight: null,
    value: 'SHOPIFY_JP',
    label: '',
    average_delivery_time: ''
  }
};
// SHIPPING_METHODSに要素が追加されるごとにレポート作成系に影響が出るのに注意。
// - shipmentService.sendActualShippingChargeForDailySalesMail
// - shipment.sendActualShippingChargeForDailyShippingMail
// 等

const SHIPPING_METHODS_PATTERN = Object.keys(SHIPPING_METHODS).map(
  (k) => SHIPPING_METHODS[k].value
);

module.exports = {
  SHIPPING_METHODS,
  SHIPPING_METHODS_PATTERN,
  SHIPPING_METHODS_RECOMMEND,
  SHIPPING_METHODS_RECOMMEND_PATTERN
};
